import { useEffect, useState } from 'react';
import { FETCH_TEAMS_ERROR_MESSAGE } from 'constants/errorMessages';
import { serializeNameAndUUID } from 'utilities/api';
import { useUnmountIgnore } from 'utilities/useUnmountIgnore';
import { useSnackbar } from 'utilities/hooks/useSnackbar/useSnackbar';
import { useLazyGetTeamsQuery } from 'store/apis/teamsApi';

export const useSerializedTeams = () => {
  const unmountIgnore = useUnmountIgnore();
  const { showError } = useSnackbar();
  const [team, setTeam] = useState();
  const [selectableTeams, setSelectableTeams] = useState([]);

  const [getTeams] = useLazyGetTeamsQuery();

  useEffect(() => {
    getTeams()
      .unwrap()
      .then((response) => {
        const teams = response.map(serializeNameAndUUID);

        // this is used to default to a primary team when someone is making their order (most users will probably only have one team)
        const firstTeam = serializeNameAndUUID(response[0]);
        if (!unmountIgnore.current) {
          setTeam(firstTeam);
          setSelectableTeams(teams);
        }
      })
      .catch(() => showError(FETCH_TEAMS_ERROR_MESSAGE));
  }, [unmountIgnore]);

  return {
    team,
    selectableTeams,
  };
};
